import React, { useState } from "react";
import CardAction from "../CardAction";
import Item from "../../atoms/Item";
import { ROUTE_HOME } from "../../../shared/constants";
import Loading from "../../../../shared/Loading/Loading";
import { redirectToLogin } from "../../../../../js/shared/utils";
import { getUserToken } from "../../../shared/utils";

const DefaultOfferCard = () => {
	const [loading, setLoading] = useState(false);

	const redirect = () => {
		window.history.pushState(ROUTE_HOME.toString(), document.title, ROUTE_HOME);
		if (getUserToken()) {
			window.location.href = ROUTE_HOME;
		} else {
			redirectToLogin(window);
		}
		setLoading(true);
	};

	return (
		<CardAction
			title="VENDA CONVENCIONAL"
			titleIcon="icon-max-action-gear"
			button="Vender"
			buttonClick={redirect}
			buttonData="quick-sale-sell-default"
		>
			{loading ? (
				<Loading width="120px" height="120px" />
			) : (
				<>
					<Item marginMultiplier={2}>Você define o valor que deseja por suas milhas</Item>
					<Item marginMultiplier={2}>Venda de milhas nacionais e internacionais</Item>
					<Item marginMultiplier={2}>Você escolhe os detalhes da sua oferta</Item>
				</>
			)}
		</CardAction>
	);
};

export default DefaultOfferCard;
